<div class="range-slider"
     [style.--track-gradient]="trackGradient"
     [style.--start]="startPct + '%'"
     [style.--end]="endPct + '%'">
    <div class="track"></div>
    <div class="track-title">
        <span [ngClass]="{disabled: start !== min}">{{ min }}</span>
        <span [ngClass]="{disabled: end !== max}">{{ max }}</span>
    </div>
    @if (invert) {
        <div class="track-overlay"
             [style.left]="startPct + '%'"
             [style.right]="100-endPct + '%'"></div>
    } @else {
        <div class="track-overlay"
             [style.right]="100-startPct + '%'"></div>
        <div class="track-overlay"
             [style.left]="endPct + '%'"></div>
    }

    <input type="range" class="thumb thumb--start"
           [min]="min" [max]="max" [step]="step"
           form
           [value]="start"
           (input)="onStart($event)"
           (blur)="onTouched()"
           [style.--thumb-color]="startColor">

    <input type="range" class="thumb thumb--end"
           [min]="min" [max]="max" [step]="step"
           [value]="end"
           (input)="onEnd($event)"
           (blur)="onTouched()"
           [style.--thumb-color]="endColor">

    <div class="slider-values">
        @if (min !== start) {
            <span class="value start" [style.left]="'calc(' + startPct + '% - ' + (startPct/10) + 'px)'">
          {{ start | number:'1.0-0' }}
        </span>
        }
        @if (max !== end) {
            <span class="value end" [style.left]="'calc(' + endPct + '% - ' + (endPct/10) + 'px)'">
          {{ end | number:'1.0-0' }}
        </span>
        }
    </div>
</div>
